import React from 'react';
import PropTypes from 'prop-types';
import Error from './error-screen';
import illustrations from '../assets/illustrations';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
export default function GatewayTimeout(props) {
  return /*#__PURE__*/React.createElement(Error, {
    title: "We're currently experiencing a delay in processing your request",
    label: "Error 504",
    paddingBottom: 125,
    illustration: illustrations.Error504
  }, /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.gray400
  }, "Please try again in a moment. Thank you for your understanding and patience!"), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.advanceBlue400,
    textDecorationLine: "underline",
    onPress: props.onPressLink
  }, "Back to Home"));
}
GatewayTimeout.defaultProps = {
  onPressLink: () => null
};
GatewayTimeout.propTypes = {
  onPressLink: PropTypes.func
};
//# sourceMappingURL=504.js.map